import { Box, Flex, Stack } from "../../mantine-passthroughs/index.js";
import { Avatar } from "../../avatar/Avatar.js";
import { Fragment } from "react";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/card/internal/CardContents.tsx
const CardContents = ({ header = null, footer = null, pinFooter = false, Icon, iconColor = "primary", iconBackground, children }) => {
	const contents = [
		header,
		children,
		footer
	].reduce((acc, section, index) => {
		if (!section) return acc;
		return /* @__PURE__ */ jsxs(Fragment, { children: [acc, /* @__PURE__ */ jsx(Box, {
			flex: pinFooter && index === 1 ? 1 : void 0,
			children: section
		})] });
	}, /* @__PURE__ */ jsx(Fragment, {}));
	if (Icon) return /* @__PURE__ */ jsxs(Flex, {
		gap: "xxs",
		children: [/* @__PURE__ */ jsx(Box, { children: iconBackground ? /* @__PURE__ */ jsx(Avatar, {
			color: iconBackground,
			AvatarIcon: () => /* @__PURE__ */ jsx(Icon, { color: iconColor })
		}) : /* @__PURE__ */ jsx(Icon, { color: iconColor }) }), /* @__PURE__ */ jsx(Stack, {
			gap: "sm",
			flex: 1,
			children: contents
		})]
	});
	return /* @__PURE__ */ jsx(Stack, {
		gap: "sm",
		flex: 1,
		children: contents
	});
};

//#endregion
export { CardContents };